export var CrawlerSourceSorting;
(function (CrawlerSourceSorting) {
    CrawlerSourceSorting["POPULAR"] = "popular";
    CrawlerSourceSorting["LATEST"] = "latest";
})(CrawlerSourceSorting || (CrawlerSourceSorting = {}));
